"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _image2 = _interopRequireDefault(require("./image"));
var _text2 = _interopRequireDefault(require("./text"));
var _number2 = _interopRequireDefault(require("./number"));
var _combined2 = _interopRequireDefault(require("./combined"));
var _constants = require("./resources/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = {
  text: function text(_ref) {
    var value = _ref.value,
      category = _ref.category,
      _ref$dataSource = _ref.dataSource,
      dataSource = _ref$dataSource === void 0 ? _constants.DATA_SOURCE.NORWAY : _ref$dataSource;
    var args = {
      value: value,
      category: category,
      dataSource: dataSource
    };
    return {
      data: (0, _text2.default)(args)
    };
  },
  number: function number(_ref2) {
    var value = _ref2.value,
      category = _ref2.category;
    var args = {
      value: value,
      category: category
    };
    return {
      data: (0, _number2.default)(args)
    };
  },
  image: function image(_ref3) {
    var value = _ref3.value,
      category = _ref3.category,
      _ref3$extension = _ref3.extension,
      extension = _ref3$extension === void 0 ? 'svg' : _ref3$extension,
      _ref3$dataSource = _ref3.dataSource,
      dataSource = _ref3$dataSource === void 0 ? _constants.DATA_SOURCE.NORWAY : _ref3$dataSource,
      baseUrl = _ref3.baseUrl;
    var args = {
      value: value,
      category: category,
      extension: extension,
      dataSource: dataSource,
      baseUrl: baseUrl
    };
    return {
      data: (0, _image2.default)(args)
    };
  },
  combined: function combined(_ref4) {
    var value = _ref4.value,
      category = _ref4.category,
      _ref4$dataSource = _ref4.dataSource,
      dataSource = _ref4$dataSource === void 0 ? _constants.DATA_SOURCE.NORWAY : _ref4$dataSource;
    var args = {
      value: value,
      category: category,
      dataSource: dataSource
    };
    return {
      data: (0, _combined2.default)(args)
    };
  }
};
exports.default = _default;
//# sourceMappingURL=translate.js.map